import React from 'react';
// import { MetricsMobilization } from '../../../../../components/metrics'
import { Title } from '../../../../../components/title';

const MobilizationsSettingsMetricsPage = () => (
  <React.Fragment>
    <Title>Métricas</Title>
    <h3>Override MetricsMobilization</h3>
    {/* <MetricsMobilization mobilizationId={props.mobilization.id} /> */}
  </React.Fragment>
);

export default MobilizationsSettingsMetricsPage;
